<template>
  <div>
    <Header :useruid="this.$route.params.useruid" :title="$t('newsletter.manage_newsletter')" :showDate="true"></Header>
    <div class="fit-width" style="margin: auto;max-width:800px;">
      <div id="top-div"></div>
      <Tip :tipNumber="19"></Tip>
      <div style="display:grid; grid-template-columns: auto auto;top: 30px;position: relative;">
        <b-button class="submit-button4" v-if="!previewing" v-on:click="showLayoutEdit=true;" variant="clear-blue" style="margin-left: auto;margin-right: 0px;grid-column: 2;"><div class="configure-button"></div><span style="font-weight:bold;">{{$t('general.configure_layout')}}</span></b-button>
      </div>
      <form v-on:submit.prevent="updateNewsletter" v-if="!previewing" class="fit-width" style="margin: auto;">
        <!--<b>{{(newsletter.backup_date_formatted != null || next_meeting != null? ": "+$d(new Date((newsletter.backup_date_formatted != null && newsletter.backup_blocks>0?  newsletter.backup_date_formatted : next_meeting)+" 00:00:01"), 'short') : '')}}</b>-->
        <span class="form-box-title">{{$t('newsletter.newsletter_header') }} <b-form-select v-if="!is_parent" v-model="newsletter.send_date" :options="newsletter_dates" value-field="value" text-field="text"/></span>
        <draggable :disabled="true" tag="div" v-model="newsletterObjects" class="form-box" style="grid-template-columns: 100%; ">
          <!--<div v-if="newsletter.backup_date_formatted != null && newsletter.backup_blocks>0" style="padding-bottom:10px; margin-bottom: 10px; border-bottom: 1px dashed #e9e9e9;">
              {{$t('newsletter.backup_message')}}
          </div>-->
          <div  v-for="o in newsletterObjects" :key="o.id">
             <div class="newsletter-admin-box" v-if="(o.id == 3 && !isCorporateConnections) || (o.id==2 && isCorporateConnections)">
              <span class="form-box-name">{{isCorporateConnections? $t('newsletter.newsletter_blockc3') : $t('newsletter.newsletter_block3')}}</span>
              <div style="display:grid; grid-template-columns: max-content max-content;margin: 10px 0px;grid-gap: 20px;">
                  <b-form-checkbox v-model="newsletter.custom_header" value="0" unchecked-value="1">
                      {{$t('newsletter.use_default')}}
                  </b-form-checkbox>
                  <b-form-checkbox v-model="newsletter.custom_header" value="1" unchecked-value="0">
                      {{$t('newsletter.use_custom')}}
                  </b-form-checkbox>
                  <div v-if="newsletter.custom_header==1" style="display:grid; grid-template-columns: auto auto;grid-column:1/3;">
                      <b-button class="submit-button4" v-on:click="openPhotoEdit((s => newsletter.header_image = s),newsletter.header_image,true,600)" variant="clear-blue"><div class="preview-button"></div><span>{{$t('global.set_image')}}</span></b-button>
                      <img style="height:60px;" v-if="newsletter.header_image && newsletter.header_image.length>0" :src="newsletter.header_image">
                  </div>
              </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 14 && !isCorporateConnections">
              <span  class="form-box-name">{{$t('newsletter.newsletter_block14')}}</span>
              <div  style="display:grid; grid-template-columns: max-content max-content max-content;margin: 10px 0px;grid-gap: 20px;">
                 <span style="margin: auto;margin-left: 5px;color: #555;">{{newsletter.asks_missing>0? $t('newsletter.asks_missing', {asks: newsletter.asks_missing}) : $t('newsletter.asks_complete')}}</span>
                  <b-button style="margin: auto;" class="submit-button4" v-if="newsletter.asks_missing>0" v-on:click="showReferralConfirm=true;" variant="clear-blue"><div class="email-button"></div><span>{{$t('newsletter.send_reminder')}}</span></b-button>
              </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 31">
              <span  class="form-box-name">{{$t('newsletter.newsletter_block31')}}</span>
              <div  style="display:grid; grid-template-columns: max-content max-content max-content;grid-gap: 20px;">
                 <span style="margin: auto;margin-left: 5px;color: #555;">{{$t('newsletter.num_meetings')}}</span>
                  <b-form-select  v-model="newsletter.num_meetings" :options="[{value:1,text:'1'},{value:2,text:'2'},{value:3,text:'3'},{value:4,text:'4'}]" value-field="value" text-field="text"/>
              </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 13">
              <span  class="form-box-name">{{$t('newsletter.newsletter_block13')}}</span>
              <div  style="display:grid; grid-template-columns: max-content max-content max-content;margin: 10px 0px;grid-gap: 20px;">
                  <span style="color: color: #999;">{{ $t('newsletter.cat_order')}}</span>
                    <b-form-checkbox v-model="newsletter.categories_order" value="0" unchecked-value="1">
                        {{$t('newsletter.cat_list')}}
                    </b-form-checkbox>
                    <b-form-checkbox v-model="newsletter.categories_order" value="1" unchecked-value="0">
                        {{$t('newsletter.cat_random')}}
                    </b-form-checkbox>
                </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 4">
                <span class="form-box-name">{{$t('newsletter.newsletter_block4')}}</span>
              <div >
                <multiselect  :noOptions="$t('global.empty_list')" :class="{blueselect:true}" :max="2" :selectedLabel="$t('global.selected_text')" selectLabel="" deselectLabel="" v-model="newsletter.performance_select" :options="tracking_nums" :multiple="true" :close-on-select="false"  :preserve-search="true" :placeholder="$t('general.select_periods')" label="text" track-by="value" :preselect-first="false">
                </multiselect>
                <div v-show="no_data.length>0" >{{$t('newsletter.no_performance')+": "+(no_data.map(v => $t('general.tracking_option_'+v)).join(", "))}}</div>
              </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 17">
              <span  class="form-box-name">{{$t('newsletter.newsletter_block17')}}</span>
              <b-form-select  v-model="newsletter.core_value" :options="coreOptions.filter(v => isCorporateConnections? v.value>7 : v.value<=7)" value-field="value" text-field="text"/>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 1">
              <span class="form-box-name">{{$t('newsletter.newsletter_block1')}}</span>
              <BaseEditor :content="topMessage" />
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 7">
              <span class="form-box-name">{{$t('newsletter.newsletter_block7')}}</span>
              <BaseEditor :content="meetingRecap" />
              <b-form-checkbox v-model="newsletter.meeting_recap_pic" style="grid-column: 2/3;" value="1" unchecked-value="0">
                  {{$t('newsletter.meting_recap_pic')}}
              </b-form-checkbox>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 9">
              <span  class="form-box-name">{{$t('newsletter.newsletter_block9')}}</span>
              <BaseEditor :content="newsNotifications" />
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 8">
              <span class="form-box-name">{{$t('newsletter.newsletter_block8')}}</span><b-form-input v-model="newsletter.visitors_note" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" ></b-form-input>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 15 && !isCorporateConnections">
              <span class="form-box-name">{{$t('newsletter.newsletter_block15')}}</span>
              <BaseEditor :content="closingNote" />
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 16">
              <span class="form-box-name">{{$t('newsletter.newsletter_block16')}}</span>
              <BaseEditor :content="bottomMessage" />
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 20">
              <span class="form-box-name">{{$t('newsletter.newsletter_block20')}}</span><b-form-select style="margin:auto;" v-model="newsletter.best_weekly" :options="members" value-field="id" text-field="name"/>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 21">
              <span class="form-box-name">{{$t('newsletter.newsletter_block21')}}</span>
              <BaseEditor :content="mediaHeader" />
              <div v-if="media_links==0" style="margin: auto 0;grid-column:2/3;">{{$t('newsletter.define_social_media')}} <b-button variant="link" style="padding:0px;" v-on:click="goToSettings">{{$t('newsletter.chapter_settings')}}</b-button></div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 22 && !is_parent">
              <span class="form-box-name">{{$t('newsletter.newsletter_block22')}}</span>
              <b-form-checkbox v-model="newsletter.regional_events" value="1" unchecked-value="0" style="margin:auto 0;">
                    {{$t('newsletter.include_regional')}}
                </b-form-checkbox>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 25">
              <span class="form-box-name">{{$t('newsletter.newsletter_block25')}}</span>
              <BaseEditor :content="photoDescription" />
              <div style="grid-column:2;">
                  <div v-for="photo in galleryPhotos" :key="photo.number" class="gallery-image" :style="{'background-image': 'url(\''+(photo.link? photo.link : photo.base64)+'\')'}" ></div>
              </div>
              <div style="display:grid; grid-template-columns: auto auto;grid-column: 2;">
                <i :style="{'font-weight': galleryPhotos.length>0? 'bold' : 'normal'}">{{$tc('newsletter.number_photos_selected', galleryPhotos.length)}}</i>
                <b-button style="grid-column:2; margin-left:auto;margin-top:5px;" class="submit-button4" v-on:click="showGalleryPhotos=true;" variant="blue"><span>{{$t('newsletter.select_photos')}}</span></b-button>
              </div>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 26">
              <span class="form-box-name">{{$t('newsletter.newsletter_block26')+" #"+o.custom_id}}</span>
              <b-form-input v-model="o.title" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" ></b-form-input>
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 27">
              <span class="form-box-name">{{$t('newsletter.newsletter_block27')+" #"+o.custom_id}}</span>
              <BaseEditor :content="o" />
            </div>
            <div class="newsletter-admin-box" v-if="o.id == 28">
              <span class="form-box-name">{{$t('newsletter.newsletter_block28')+" #"+o.custom_id}}</span>
              <b-form-input v-model="o.title" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" ></b-form-input>
              <div style="grid-column: 2;">
                <div v-for="member in o.members" :key="member.id" style="border: 1px solid gray;padding: 5px;margin:2px;"><b>{{member.name}}</b>{{member.company? " - "+member.company: ""}}</div>
              </div>
              <div style="display:grid; grid-template-columns: auto auto;grid-column: 2;">
                <i :style="{'font-weight': galleryPhotos.length>0? 'bold' : 'normal'}">{{$tc('newsletter.number_members_selected', o.members? o.members.length : 0)}}</i>
                <b-button style="grid-column:2; margin-left:auto;margin-top:5px;" class="submit-button4" v-on:click="openMemberSelection(o)" variant="blue"><span>{{$t('newsletter.select_members')}}</span></b-button>
              </div>
            </div>
            
          </div>
        </draggable>
        <b-modal id="slide-modal" centered  v-model="showLayoutEdit" :title="$t('general.configure_layout')">
              <div style="display: grid;grid-template-columns: max-content auto;">
               <!-- <b-form-checkbox v-model="newsletter.dense" value="1" unchecked-value="0" style="padding-left:35px;">
                        {{$t('newsletter.dense_objects')}}
                </b-form-checkbox>
                <div style="text-align:left; font-size: 14px; color: #cccccc;padding-left:10px;">*{{$t('newsletter.dense_note')}}</div>-->
                <div style="display:grid; grid-template-columns: 1fr 1fr;grid-column: 1/3;text-align:center;">
                  <div>{{$t('newsletter.newsletter_layout')}}</div>
                  <div>{{$t('newsletter.unset_objects')}}</div>
                  <draggable class="nLayout" tag="div" group="newsletter" v-model="newsletterObjects"  @end="endDrag" @start="startDrag">
                    <div :id="'unused_'+o.id+(o.custom_id>0?  '_'+o.custom_id : '')" :class="{'dragged-object' : (o.id+(o.custom_id>0?  '_'+o.custom_id : '')==currentDrag)}" class="nObject" v-for="o in newsletterObjects" :key="o.id" :style="{'grid-column': 'span '+o.cspan, 'grid-row': 'span '+o.rspan}">
                      <span>{{isCorporateConnections && $t("newsletter.newsletter_blockc"+o.id)!="newsletter.newsletter_blockc"+o.id?  $t("newsletter.newsletter_blockc"+o.id) : $t("newsletter.newsletter_block"+o.id)+(o.custom_id? " #"+o.custom_id : '')}}</span>
                      <b-button v-if="(!is_parent || (isCorporateConnections && o.id==24)) && o.resizeable && (o.id==7 || o.id==22 || o.id==19 || o.id==24 || o.id==31? o.cspan>2 : o.cspan>1)" v-on:click.stop="o.cspan -=1;" class="resize-button fit-width" style='left:0px;background-color: rgba(255,255,255,0);' variant="clear-blue"><img src="../assets/button-Remove.png" /></b-button>
                      <b-button v-if="(!is_parent || (isCorporateConnections && o.id==24)) && o.resizeable && o.cspan<3 && (o.id != 29 || o.cspan<2)" v-on:click.stop="o.cspan += 1;" class="resize-button fit-width" style='background-color: rgba(255,255,255,0);' variant="clear-blue"><img src="../assets/button-Add.png" /></b-button>
                    </div>
                  </draggable> 
                  <draggable class="nLayout" tag="div" group="newsletter" v-model="unusedObjects" style="grid-auto-flow: dense;" @choose="dragChoose" @end="endDragUnused" @start="startDrag">
                    <div :id="'block_'+o.id+(o.custom_id>0?  '_'+o.custom_id : '')" :class="{'dragged-object' : (o.id+(o.custom_id>0?  '_'+o.custom_id : '')==currentDrag)}" class="nObject" v-for="o in unusedObjects" :key="o.id" :style="{'grid-column': 'span '+o.cspan, 'grid-row': 'span '+o.rspan}">
                      <span>{{isCorporateConnections && $t("newsletter.newsletter_blockc"+o.id)!="newsletter.newsletter_blockc"+o.id?  $t("newsletter.newsletter_blockc"+o.id) : $t("newsletter.newsletter_block"+o.id)}}</span>
                      <b-button v-if="(!is_parent || (isCorporateConnections && o.id==24)) && o.resizeable && (o.id==7 || o.id==22  || o.id==19 || o.id==24 || o.id==31? o.cspan>2 : o.cspan>1)" v-on:click.stop="o.cspan -=1;" class="resize-button  fit-width" style='left:0px;' variant="clear-blue"><img src="../assets/button-Remove.png" /></b-button>
                      <b-button v-if="(!is_parent || (isCorporateConnections && o.id==24)) && o.resizeable && o.cspan<3 && (o.id != 29 || o.cspan<2)" v-on:click.stop="o.cspan += 1;" class="resize-button  fit-width" variant="clear-blue"><img src="../assets/button-Add.png" /></b-button>
                    </div>
                  </draggable>
                  <div style="grid-column: 1/3;text-align:left; font-size: 14px; color: #cccccc;padding-left:10px;">*{{$t('newsletter.layout_note1')}}</div>
                  <div style="grid-column: 1/3;text-align:left; font-size: 14px; color: #cccccc;padding-left:10px;">*{{$t('newsletter.layout_note2')}}</div>
                  <div style="grid-column: 1/3;text-align:left; font-size: 14px; color: #cccccc;padding-left:10px;">*{{$t('newsletter.layout_note3')}}</div>
                   <!--<div style="grid-column: 1/3;text-align:left; font-size: 14px; color: #cccccc;padding-left:10px;">*{{$t('newsletter.layout_note4')}}</div>-->
                </div>
              </div>
              <div slot="modal-footer" class="submit-box-2" style="grid-template-columns: max-content auto;width:100%;">
                 <b-button class="submit-button4" v-on:click="showLayoutReset=true;" variant="clear-blue"><div class="reset-button"></div><span>{{$t('global.button_reset')}}</span></b-button>
                <b-button class="submit-button4" v-on:click="showLayoutEdit=false" variant="clear-blue" style="margin:auto;"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
              </div>
         </b-modal>
         <b-modal id="slide-modal"  v-model="showMemberSelection" centered :title="$t('newsletter.member_group_selections')">
           <div v-if="selectedMemberObject" >
             <multiselect  style="grid-column:2;margin-bottom: 10px;" :noOptions="$t('global.empty_list')" :class="{blueselect:true}" :selectedLabel="$t('global.selected_text')" selectLabel="" deselectLabel="" v-model="selectedMemberObject.members" :options="members.filter(v=>v.id>0)" :multiple="true" :close-on-select="false"  :preserve-search="true" :placeholder="$t('global.select_members')" label="name" track-by="id" :preselect-first="false">
               <template slot="option" slot-scope="props">
                <div><span>{{ props.option.org_name }}</span> > <span>{{ props.option.name }}</span>  <span >{{ props.option.company? " - "+props.option.company: ""}}</span></div>
              </template>
              </multiselect>
              <div class="form-box" style="width:600px;margin:auto;grid-template-columns: 100%;">
                <draggable  tag="div" v-model="selectedMemberObject.members" >
                  <div v-for="m in selectedMemberObject.members" :key="m.id" style="display:grid; grid-template-columns: auto 35px;padding:10px; border: 1px solid gray;padding: 5px;margin:2px;">
                    <div><b>{{m.name}}</b>{{m.company? " - "+m.company: ""}}</div>
                    <!--<b-button class="close-button" variant="clear-blue" v-on:click="deleteMember(m)"></b-button>-->
                  </div>
              </draggable>
              <div style="text-align:right;font-size:14px;">*{{$t('questions.drag_order')}}</div>
            </div>
           </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showMemberSelection=false;" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
         <b-modal id="slide-modal"  v-model="showGalleryPhotos" centered >
           <div slot="modal-header" style="width:100%;">
             <div style="font-size: 20px;">{{$t('newsletter.photo_selection')}}</div>
            <b-button class="submit-button4" style="margin:auto;" v-on:click="openPhotoEdit((s => addPhotoToGallery(s)),null,false,200,200)" variant="blue"><span>{{$t('entry.upload_photo')}}</span></b-button>
          </div>
          <draggable  tag="div" v-model="galleryPhotos" >
              <div v-for="photo in galleryPhotos" :key="photo.number" style="display:grid; grid-template-columns: 250px auto 35px;padding:10px; border: 1px solid gray;">
                <div :src="photo.link" class="gallery-image" :style="{'margin':'auto', 'background-image': 'url(\''+(photo.link? photo.link : photo.base64)+'\')'}" ></div>
                <b-form-textarea v-model="photo.description" pattern="[^<>]*" :title="$t('global.pattern_title')" style="margin-bottom: 10px;" placeholder="" :rows="3" :max-rows="3" />
                <b-button class="trash-button" variant="blue" v-on:click="deletePhoto(photo)"></b-button>
              </div>
          </draggable>
          <div style="text-align:right;font-size:14px;">*{{$t('questions.drag_order')}}</div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showGalleryPhotos=false;" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
         <b-modal id="modal-center" v-model="showLayoutReset" centered :title="$t('newsletter.reset_title')">
          <div >
              {{$t('newsletter.reset_message')}}
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showLayoutReset=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="resetLayout" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
        <div class="submit-box-2" style="display: grid;grid-template-columns: auto auto auto;grid-auto-flow: inherit;">
          <b-button class="submit-button4" v-if="permissions.organization.id == 90 || permissions.organization.porg==90 || permissions.organization.porg==481 || permissions.organization.id == 492" v-on:click="preview(true)" variant="clear-blue"><div class="preview-button"></div><span>PREVIEW NON BACKUP</span></b-button>
          <b-button class="submit-button4" v-if="permissions.organization.id == 90 || permissions.organization.porg==90 || permissions.organization.porg==481 || permissions.organization.id == 492" style="margin:auto;" v-b-popover.hover.top="$t('newsletter.test_send_to')" v-on:click="showSendTestModal(false)" variant="clear-blue"><div class="email-button"></div><span>TEST SEND NON BACKUP</span></b-button>
          <b-button class="submit-button4" v-if="permissions.organization.id == 90 || permissions.organization.porg==90 || permissions.organization.porg==481 || permissions.organization.id == 492" v-on:click="showSendModal(false)" variant="clear-blue"><div class="email-button"></div><span>SEND NON BACKUP</span></b-button>
  
          <b-button class="submit-button4" v-on:click="preview(true)" variant="clear-blue"><div class="preview-button"></div><span>{{$t('global.button_preview')}}</span></b-button>
          <b-button class="submit-button4" style="margin:auto;" v-b-popover.hover.top="$t('newsletter.test_send_to')" v-on:click="showSendTestModal(true)" variant="clear-blue"><div class="email-button"></div><span>{{$t('newsletter.test_newsletter')}}</span></b-button>
          <b-button class="submit-button4"  v-on:click="showSendModal(true)" variant="clear-blue"><div class="email-button"></div><span>{{$t('newsletter.send_newsletter')}}</span></b-button>
          <b-button v-if="permissions.organization.id==7 || permissions.organization.id == 90 || permissions.organization.porg==90 || permissions.organization.porg==481 || permissions.organization.id == 492" class="submit-button4" v-on:click="backupNewsletter" variant="clear-blue"><div class="configure-button"></div><span>BACKUP</span></b-button>
          <b-button class="submit-button4" style="grid-column:2;" type="submit" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_save')}}</span></b-button>
        </div>
        
         
        <b-modal id="modal-center" v-model="showReferralConfirm" centered :title="$t('newsletter.referral_email_title')">
          <div >
            {{$t('newsletter.referral_email_text',{asks: newsletter.asks_missing})}}
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showReferralConfirm=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="sendAskRequestEmails" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
        
        <b-modal id="modal-center" v-model="showNewsletterSend" centered :title="$t('newsletter.send_newsletter')">
          <div >
            <div v-if="confirm_step==0">{{$t('newsletter.empty_recap')}}</div>
            <div v-if="confirm_step==1"><span v-html="joint_meeting? $t('newsletter.confirm_both', {date: $d(new Date(newsletter.send_date+' 00:00:01'), 'short')}): $t('newsletter.confirm_text', {date: $d(new Date(newsletter.send_date+' 00:00:01'), 'short')})"></span></div>
            <div v-if="confirm_step==1" style="font-size:12px;">*{{$t('newsletter.date_note')}}</div>
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showNewsletterSend=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="confirmSend" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
        <b-modal id="send-modal" v-model="showNewsletterRegionalSend" centered :title="$t('newsletter.send_newsletter')">
          <div >
            <div>{{$t('newsletter.regional_send_select')}}</div>
            <div style="text-align: left;margin: auto;" class="fit-width">
                <b-form-checkbox v-model="regionalSendOptions.chapters" value="1" unchecked-value="0">
                  {{$t('newsletter.chapters_text')}}
              </b-form-checkbox>
              <b-form-checkbox v-model="regionalSendOptions.startups" value="1" unchecked-value="0">
                  {{$t('newsletter.startups_text')}}
              </b-form-checkbox>
              <b-form-checkbox v-model="regionalSendOptions.rst" value="1" unchecked-value="0">
                  {{$t('newsletter.rst_text')}}
              </b-form-checkbox>
            </div>
            <div v-html="$t('newsletter.members_to_send', {members: regionalMembers.chapters_members*regionalSendOptions.chapters+regionalMembers.startups_members*regionalSendOptions.startups+regionalMembers.rst_members*regionalSendOptions.rst, chapters: regionalMembers.chapters*regionalSendOptions.chapters+regionalMembers.startups*regionalSendOptions.startups+regionalMembers.rst*regionalSendOptions.rst})"></div>
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showNewsletterRegionalSend=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="confirmRegionalSend" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_yes')}}</span></b-button>
          </div>
        </b-modal>
        <b-modal id="modal-center" v-model="showTestNewsletter" centered :title="$t('newsletter.test_newsletter')">
          <div style="display: grid; grid-template-columns: auto auto;">
            <span class="form-box-name">{{$t('newsletter.test_recipient')}}</span>
            <b-form-input v-model="testEmail" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" :state="validEmail" @input="validateEmail"></b-form-input>
            <div style="grid-column:1/3;" v-html="$t('newsletter.confirm_test')"></div>
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showTestNewsletter=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" :disabled="!validEmail" v-on:click="confirmTest" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
         <b-modal id="modal-center" v-model="showImageModal" centered :title="$t('newsletter.image_title')">
          <div>
             <div style="display:grid; grid-template-columns: max-content max-content;margin: 10px 0px;grid-gap: 20px;">
                <b-form-checkbox v-model="image_type" value="1" unchecked-value="0">
                    {{$t('newsletter.image_url')}}
                </b-form-checkbox>
                <b-form-checkbox v-model="image_type" value="0" unchecked-value="1">
                    {{$t('newsletter.image_upload')}}
                </b-form-checkbox>
            </div>
              <div v-if="image_type==1">
                <b-form-input v-model="imgurl" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" ></b-form-input>
              </div>
              <div v-if="image_type==0">
                <b-button class="submit-button4" v-on:click="showPhotoEdit=false;openPhotoEdit((s => setImageByURL(s)),null,false,maxwidth)" variant="clear-blue"><div class="preview-button"></div><span>{{$t('global.set_image')}}</span></b-button>
              </div>
            </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showImageModal=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button v-if="image_type==1" class="submit-button4" v-on:click="setImageByURL(imgurl)" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_ok')}}</span></b-button>
          </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" id="modal-center" v-model="showEventDisable" centered :title="$t('newsletter.disable_email')">
          <div v-html="emailDisableNote">
            </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showEventDisable=false;" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_no')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="runEmailDisabledCallback()" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_yes')}}</span></b-button>
          </div>
        </b-modal>
        <b-modal id="slide-modal" centered  v-model="showPhotoEdit" :title="$t('global.set_image')">
          <b-form-file id='fileid' accept="image/jpeg, image/png, image/gif" @change="setImage" plain hidden></b-form-file>
          <div :style="{'display': 'grid', 'grid-template-columns': 'min-content max-content auto'}">
            <div id="rotate-options">
              <b-button v-if="imageEdit.preview && imageEdit.preview.length>0" v-on:click="rotateImageRight" class="image-button" variant="clear-blue"><div class="rotate-left-button"></div></b-button>
              <b-button v-if="imageEdit.preview && imageEdit.preview.length>0" v-on:click="rotateImageLeft" class="image-button" variant="clear-blue"><div class="rotate-right-button"></div></b-button>
              <b-button v-if="imageEdit.preview && imageEdit.preview.length>0" v-on:click="flipImageX()"  class="image-button" variant="clear-blue"><div class="flip-y-button"></div></b-button>
              <b-button v-if="imageEdit.preview && imageEdit.preview.length>0" v-on:click="flipImageY()" class="image-button" variant="clear-blue"><div class="flip-x-button"></div></b-button>
            </div>
            <div style="width: auto; height:300px; margin: 20px auto; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :guides="true" :view-mode="2" drag-mode="crop" :auto-crop="true" :auto-crop-area="1"
                            :min-container-width="100" :min-container-height="100" :background="true" :rotatable="true"
                            :src="imageEdit.preview" :aspectRatio="imageEdit.fixed? (isCorporateConnections? 1.392 : 2.83) : NaN" :cropmove="cropMove" alt="Source Image"
                            :img-style="{ 'width': 'auto', 'height': '300px', 'max-width':'300px' }">
              </vue-cropper>
            </div>
            <img id="set-news-preview" style="width:100%;height:100%;object-fit: contain;" v-show="imageEdit.preview"  :src="imageEdit.preview" />
            <div id="zoom-text">{{$t('member.zoom_text')}}</div>
            <b-button class="submit-button4" v-on:click="openDialog" variant="blue" style="grid-column:2/3;margin: auto;">{{$t('memberphoto.upload_photo')}}</b-button>
          </div>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showPhotoEdit=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="cropImage" variant="clear-blue"><div class="save-button"></div><span>{{$t('memberphoto.set_photo')}}</span></b-button>
          </div>
        </b-modal>
      </form>
      
      <b-button v-if="previewing" class="submit-button4" style="margin: 10px auto;" v-on:click="previewing=false" variant="clear-blue"><div class="back-button"></div><span>{{$t('global.button_back')}}</span></b-button>
      <div v-if="previewing" class="div-space fit-width" v-html="previewhtml" style="margin:auto;"></div>
      <b-button v-if="previewing" class="submit-button4" style="margin: 10px auto;" v-on:click="previewing=false" variant="clear-blue"><div class="back-button"></div><span>{{$t('global.button_back')}}</span></b-button>
      <div style="width:100%;height:50px;"></div>
    </div>
    <Footer :useruid="this.$route.params.useruid"></Footer>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.dragged-object{
  border-color: red;
  border-width: 2px;
}
.gallery-image{
  width:100px;height:100px;
  background-size: contain !important;
  background-position:center;
      background-repeat: no-repeat;
    display: inline-block;
}
.newsletter-admin-box{
  display: grid;
  grid-template-columns: 165px 620px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #e9e9e9;
}
.blur-editor{
    border: 1px solid #ccc;
}
.blur-editor:focus{
    box-shadow: 0 0 2px 5px #bfdeff;
    border: 1px solid #62b9f5;
}
.tiptap-button{
    color:black;
    background-color: white;
    border:none;
    width: 40px;
    padding: 5px 0px;
}
.tiptap-button:hover{
    color: white;
    background-color: gray;
}
.is-active{
    background-color: lightgray;
}
 .menubar2{
    display: grid;
    grid-template-columns: repeat(7,auto);
    grid-gap: 5px;
 }
 
</style>
<script>

import Multiselect from 'vue-multiselect';
import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
    import draggable from "vuedraggable";
    
  import router from "../router"
    export default {
    name: "Newsletter",
   components: {
      VueCropper
      ,draggable, Multiselect
    },
      data() {
        return {
          testEmail: "",
          newsletter_dates: [],
          joint_meeting: false,
          next_meeting: null,
          currentDrag: "",
          regionalMembers: {chapters: 0, startups: 0, rst: 0, chapters_members: 0, startups_members:0, rst_members: 0},
          regionalSendOptions: {chapters: 1, startups: 1, rst: 1},
          showNewsletterRegionalSend: false,
          selectedMemberObject: null,
          showMemberSelection: false,
          galleryPhotos: [],
          showGalleryPhotos: false,
          justSaved: false,
          is_parent: false,
          official: true,
          showLayoutReset: false,
          showLayoutEdit: false,

        tempObjects: [{id: 1, cspan: 3, rspan: 1, resizeable: false},{id: 2, cspan: 3, rspan: 1, resizeable: false},{id: 3,  cspan: 3, rspan: 1, resizeable: false},
        {id: 4, cspan: 1, rspan: 1, resizeable: false},{id: 5, cspan: 1, rspan: 1, resizeable: false},{id: 6, cspan: 1, rspan: 1, resizeable: false},
        {id: 7,  cspan: 3, rspan: 1, resizeable: true},{id: 8, cspan: 3, rspan: 1, resizeable: false}, {id: 9,  cspan: 3, rspan: 1, resizeable: true},
        {id: 10,  cspan: 1, rspan: 1, resizeable: false},{id: 11, cspan: 1, rspan: 1, resizeable: false},{id: 12, cspan: 1, rspan: 1, resizeable: false},{id: 13, cspan: 1, rspan: 1, resizeable: false},
        {id: 14,  cspan: 3, rspan: 1, resizeable: true},{id: 15,  cspan: 3, rspan: 1, resizeable: false},{id: 16,  cspan: 3, rspan: 1, resizeable: false},{id: 17,  cspan: 1, rspan: 1, resizeable: false}
        ,{id: 18,  cspan: 1, rspan: 1, resizeable: false},{id: 19,  cspan: 2, rspan: 1, resizeable: true},{id: 20,  cspan: 1, rspan: 1, resizeable: false},{id: 21,  cspan: 3, rspan: 1, resizeable: true},
        {id: 22,  cspan: 3, rspan: 1, resizeable: true},{id: 23,  cspan: 1, rspan: 1, resizeable: false},{id: 24,  cspan: 2, rspan: 1, resizeable: true},{id: 25,  cspan: 3, rspan: 1, resizeable: false},
        {id: 26,  cspan: 3, rspan: 1, resizeable: false, max: 8,custom_id:0},{id: 27,  cspan: 3, rspan: 1, resizeable: false, max: 12,custom_id:0},{id: 28,  cspan: 3, rspan: 1, resizeable:false, max: 8,custom_id:0}
        ,{id: 29,  cspan: 1, rspan: 1, resizeable:true},{id: 30,  cspan: 1, rspan: 1, resizeable:false},{id: 31,  cspan: 3, rspan: 1, resizeable:false}],
        officialObjects: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
        startupObjects: [1, 2, 3, 6, 7, 8, 9, 10, 13, 14, 15, 16, 17, 18, 19, 23],
        rstObjects: [1, 2, 3, 6, 7, 8, 9, 10, 13, 15, 16, 17, 18, 19, 24],
        regionalObjects: [1,2,3,21,22,16,25,26,27,28],
        ccObjects: [1,2,5,6,7,8,9,10,12,14,15,16,17,18,19,21,22,30],
        ccRegionalObjects: [1,2,16,17,21,22,24,25,26,27,28,30,31],
        member: [],
        unusedObjects: [],
        newsletterObjects: [],
          showNewsletterSend: false,
          confirm_step: 0,
           previewing: false,
            previewhtml: "",
            imgurl:'',
            showImageModal: false,
            topMessage: {text: '', update: ''},
            bottomMessage: {text: '', update: ''},
            meetingRecap: {text: '', update: ''},
            newsNotifications: {text: '', update: ''},
            closingNote: {text: '', update: ''},
            photoDescription: {text: '', update: ''},
            mediaHeader: {text: '', update: ''},
          newsletter: {send_date: null, num_meetings: 1,backup_blocks: 0, backup_date_formatted: null, photo_description: '', photo_ids: '', regional_events: 0,best_weekly: 0,asks_missing: 0,meeting_recap_pic: 1,categories_order: 0,core_value: 0,custom_header: 0, header_image: '',tracking_periods: 0, split_layout: [], performance_select: [],top_message: "Stay safe and follow Covid-19 restrictions in your region.",bottom_message: "Have a great week everyone!", meeting_recap: "", news_notifications: "",visitors_note: "If you invited a member, make sure you follow-up on their visit.",
          closing_note: '<p>Visit our website at:</p><p><a href="http://www.yourbnichapter.url">www.yourbnichapter.url</a></p><p></p><p>If you have any comments or feedback on our newsletter,</p><p>please email <a href="mailto: someone@yourbnichapter.url">someone@yourbnichapter.url</a></p><p></p><p></p>', layout: "1;3,2;3,3;3,4;1,17;1,5;1,7;2,6;1,8;3,10;1,11;1,13;1,14;3,15;3,16;3", media_header: 'Connect with us on one of our channels:'},
        command: null,
        imageEdit: {data: "", preview: "", successFunc: null, fixed: true,maxwidth:0,maxheight:0},
        image_type: 0,
          showPhotoEdit: false,
        maxwidth: 0,
        useruid: "",
        tracking_nums: [],
        trackingOptions: [
          { value: 1, text: this.$t('general.tracking_option_1') },
          { value: 2, text: this.$t('general.tracking_option_2') },
          { value: 4, text: this.$t('general.tracking_option_4') },
          { value: 8, text: this.$t('general.tracking_option_8') },
          { value: 16, text: this.$t('general.tracking_option_16') },
          { value: 32, text: this.$t('general.tracking_option_32') },
          { value: 64, text: this.$t('general.tracking_option_64') },
        ],
        coreOptions:[
          { value: 1, text: this.$t('newsletter.core_option_1') },
          { value: 2, text: this.$t('newsletter.core_option_2') },
          { value: 3, text: this.$t('newsletter.core_option_3') },
          { value: 4, text: this.$t('newsletter.core_option_4') },
          { value: 5, text: this.$t('newsletter.core_option_5') },
          { value: 6, text: this.$t('newsletter.core_option_6') },
          { value: 7, text: this.$t('newsletter.core_option_7') },
          { value: 8, text: this.$t('newsletter.core_option_8') },
          { value: 9, text: this.$t('newsletter.core_option_9') },
          { value: 10, text: this.$t('newsletter.core_option_10') },
          { value: 11, text: this.$t('newsletter.core_option_11') },
          { value: 12, text: this.$t('newsletter.core_option_12') },
        ],
        no_data: [],
        showReferralConfirm: false,
        media_links: 0,
        old_newsletter: {},
        showEventDisable: false,
        organization: {disable_section_email:0,disable_share_sections:0,disable_share_speakers:0},
        emailDisableCallback: null,
        emailDisableNote: "",
        showTestNewsletter: false,
        send_backedup: false,
        validEmail: false,
        member_map: new Map(),
        members: [],
        allow_top_performing: 0
        }
      },
    methods: {
      getAllowTopPerformers() {
        this.$http.post("/api/region/get/allowedrecog"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid}).then((response) => {
          this.allow_top_performing = response.data.allow_top_performing;
          if(this.allow_top_performing){
            this.officialObjects.push(29);
          }
          this.getNewsletter();
        }).catch(() => {});
      },
      openMemberSelection(o){
        this.selectedMemberObject = o;
        this.showMemberSelection=true;
      },
      deleteMember(m){
        if(this.selectedMemberObject){
          var index = this.selectedMemberObject.members.indexOf(m);
          if (index > -1) {
            this.selectedMemberObject.members.splice(index, 1);
          }
        }
      },
      deletePhoto(photo){
        var index = this.galleryPhotos.indexOf(photo);
        if (index > -1) {
          this.galleryPhotos.splice(index, 1);
        }
      },
      addPhotoToGallery(s){
        var number = 1;
        for(number=1; number<21; number++){
          if(this.galleryPhotos.filter(v => v.number == number).length==0){
            break;
          }
        }
        this.galleryPhotos.push({number: number, link: '', base64: s, description: '', rank: this.galleryPhotos.length>0? this.galleryPhotos[this.galleryPhotos.length-1].rank+1: 1});
      },
      validateEmail() {
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.testEmail)) {
              this.validEmail= true;
          } else {
              this.validEmail= false;
          }
      },
      goToSettings(){
        if(this.permissions.access){
          router.push("/admin/general");
        }else{
          this.$bvToast.toast(this.$t('newsletter.contact_leader'), {
              variant: 'warning',
              solid: true
            });
        }
      },
      resetLayout(){
        this.tempObjects = this.tempObjects.filter(v => {
            if(this.isCorporateConnections && this.is_parent){
              return this.ccRegionalObjects.indexOf(v.id)>-1;
            }else if(this.isCorporateConnections){
              return this.ccObjects.indexOf(v.id)>-1;
            }else if(this.official==0){
              return this.startupObjects.indexOf(v.id)>-1;
            }else if(this.official==1 && this.is_parent){
              return this.regionalObjects.indexOf(v.id)>-1;
            }else if(this.official==1 && !this.is_parent){
              return this.officialObjects.indexOf(v.id)>-1;
            } else if(this.official==2){
              return this.rstObjects.indexOf(v.id)>-1;
            }
            return false;
          });
        this.newsletter.layout = "1;3,2;3,3;3,4;1,17;1,5;1,7;2,6;1,8;3,10;1,11;1,13;1,14;3,15;3,16;3";
        this.newsletter.split_layout = [];
        this.newsletterObjects = [];
        this.unusedObjects = [];
        var layoutIds = this.newsletter.layout.split(",");
            for(var x=0 ;x<layoutIds.length; x++){
              var o = layoutIds[x].split(";");
              for(var j=0; j<this.tempObjects.length;j++){
                if(o[0] == this.tempObjects[j].id+""){
                  this.newsletterObjects.push(this.tempObjects[j]);
                  if(o.length>1){
                    this.newsletterObjects[this.newsletterObjects.length-1].cspan = parseInt(o[1]);
                  }
                  break;
                }
              }
            }
            for(var y=0; y<this.tempObjects.length;y++){
               var n =this.newsletterObjects.filter(v => v.id==this.tempObjects[y].id);
                if(n.length==0 || (this.tempObjects[y].max>1 && n.length< this.tempObjects[y].max)){
                  this.unusedObjects.push(this.tempObjects[y]);
                }
          }
            var t  = this.newsletter.layout.split(",");
            for(var i=0; i<t.length; i++){
              o = t[i].split(";");
              this.newsletter.split_layout.push(o[0]);
            }
        this.showLayoutReset = false;
      },
      runEmailDisabledCallback(){
        this.showEventDisable = false; 
        if(this.emailDisableCallback != null){
          this.emailDisableCallback();
        }
      },
      showEmailDisableModal(note, callback){
        this.emailDisableNote = note;
        this.emailDisableCallback = callback;
        this.showEventDisable = true; 
      },
      endDragUnused(event){
        this.currentDrag = "";
        var htmlid = event.clone.id;
        var sp = htmlid.split("_");
        if(sp.length>1){
          var id = parseInt(sp[1]);
          var template = this.tempObjects.filter(v => v.id==id);
          var t =  this.unusedObjects.filter(v => v.id == id);
          if(template.length>0 && t.length==0){
            var max = template[0].max;
            if(max>0){
              var n = this.newsletterObjects.filter(v => v.id == id);
              if(n.length<max){
                this.unusedObjects.push(JSON.parse(JSON.stringify(template[0])));
                this.unusedObjects[this.unusedObjects.length-1].custom_id = 0;
              }
            } 
          }
        }
      },
      dragChoose(event){
         var htmlid = event.item.id;
        var sp = htmlid.split("_");
        if(sp.length>1){
          var id = parseInt(sp[1]);
          var t =  this.unusedObjects.filter(v => v.id == id)[0];
          if(t.max>0){
            var n = this.newsletterObjects.filter(v => v.id == id);
            for(var k=1; k<=12; k++){
              if(n.filter(v => v.custom_id==k).length==0){
                t.custom_id = k;
                t.title = "";
                t.text ="";
                t.update = "";
                break;
              }
            }
          }
        }
      },
      endDrag(event){
        this.currentDrag = "";
         var htmlid = event.clone.id;
        var sp = htmlid.split("_");
        if(sp.length>1){
          var id = parseInt(sp[1]);
          var n = this.unusedObjects.filter(v => v.id == id);
          if(n.length>1){
            const index = this.unusedObjects.indexOf(n[1]);
            if (index > -1) {
              this.unusedObjects.splice(index, 1);
            }
          }
        }
        
        /*this.newsletter.split_layout = [];
        for(var i=0; i<this.newsletterObjects.length;i++){
          this.newsletter.split_layout.push(this.newsletterObjects[i].id+'');
        }*/
        /*var htmlid = event.clone.id;
        var self = this;
        if(htmlid == "block_22" && this.newsletter.split_layout.indexOf("22")>-1 && this.organization.disable_events_email==0){
         this.showEmailDisableModal(this.$t("newsletter.events_disable_note"), () => {self.organization.disable_events_email=1;});
        }else if(htmlid == "unused_22" && this.newsletter.split_layout.indexOf("22")==-1 && this.organization.disable_events_email==1){
          this.showEmailDisableModal(this.$t("newsletter.events_enable_note"), () => {self.organization.disable_events_email=0;});
        }else
        if(htmlid == "block_5" && this.newsletter.split_layout.indexOf("5")>-1 && this.organization.disable_share_speakers==0){
         this.showEmailDisableModal(this.$t("newsletter.speaker_disable_note"), () => {self.organization.disable_share_speakers=1;});
        }else if(htmlid == "unused_5" && this.newsletter.split_layout.indexOf("5")==-1 && this.organization.disable_share_speakers==1){
          this.showEmailDisableModal(this.$t("newsletter.speaker_enable_note"), () => {self.organization.disable_share_speakers=0;});
        }else if(htmlid == "block_6" && this.newsletter.split_layout.indexOf("6")>-1 && this.organization.disable_share_sections==0){
         this.showEmailDisableModal(this.$t("newsletter.section_disable_note"), () => {self.organization.disable_share_sections=1;});
        }else if(htmlid == "unused_6" && this.newsletter.split_layout.indexOf("6")==-1 && this.organization.disable_share_sections==1){
          this.showEmailDisableModal(this.$t("newsletter.section_enable_note"), () => {self.organization.disable_share_sections=0;});
        }*/
      },
      startDrag(event){
        var htmlid = event.item.id;
        var sp = htmlid.split("_");
        if(sp.length>1){
          this.currentDrag = sp[1] +(sp.length>2? "_"+sp[2] : '');
        }
      },
      backupNewsletter(){
        this.$http.post("/api/organization/newsletter/backup"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid}).then((response) => {
              if(response.data.success){
                this.$bvToast.toast('backed up', {
              variant: 'success',
              solid: true
            });
              }
          }).catch(() => { });
      },
    preview(use_backup){
      // this.newsletter.meeting_recap = this.editor.getHTML();
        this.newsletter.bottom_message = this.bottomMessage.text;
        this.newsletter.top_message = this.topMessage.text;
        this.newsletter.meeting_recap = this.meetingRecap.text;
        this.newsletter.news_notifications = this.newsNotifications.text;
        this.newsletter.closing_note = this.closingNote.text;
        this.newsletter.photo_description = this.photoDescription.text;
        this.newsletter.media_header = this.mediaHeader.text;
        this.newsletter.useruid = this.useruid;
        this.newsletter.tracking_periods = 0;
        for(var i=0; i<this.newsletter.performance_select.length;i++){
          this.newsletter.tracking_periods |= this.newsletter.performance_select[i].value;
        }
        var t = "";
        for(i=0; i<this.newsletterObjects.length;i++){
          t+= (t.length==0? "": ",")+ this.newsletterObjects[i].id+";"+this.newsletterObjects[i].cspan+(this.newsletterObjects[i].custom_id>0? ";"+this.newsletterObjects[i].custom_id : "");
        }
        this.newsletter.layout = t;
        //this.$http.post("/api/organization/newsletter/update"+(this.useruid==''? "" : "/byuseruid"), this.newsletter).then((response) => {
        //  if (response.data.success === true) {

          this.newsletter.custom_objects = this.newsletterObjects.filter(v => v.custom_id>0);
          for(var i=0; i<this.newsletter.custom_objects.length;i++){
             if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length==1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members[0].id+'';
          }else if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length>1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members.reduce((v1,v2) => (v1.id? v1.id : v1)+","+v2.id);
          }else{
            this.newsletter.custom_objects[i].member_ids = '';
          }
          }
          this.newsletter.gallery_photos = this.galleryPhotos;
             
            this.$http.post("/api/organization/newsletter/build"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid, newsletter: this.newsletter, use_backup: use_backup, date: this.newsletter.send_date}).then((response) => {
              if(response.data.success){
                this.previewing = true;
                 this.previewhtml = response.data.html;
                 document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0; 
              }
          }).catch(() => { });
        //  }
       // }).catch(() => { this.$bvToast.show('serverError');});
        
    },
    
      getNewsletter() {
        this.$http.post("/api/organization/newsletter"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid}).then((response) => {
          this.is_parent = response.data.is_parent;
          
            this.official = response.data.official;
            if (response.data.success) {
              response.data.newsletter.performance_select = [];
              response.data.newsletter.split_layout = [];
              this.newsletter = response.data.newsletter;
           }
           if(this.isCorporateConnections && this.newsletter.core_value<8){
            this.newsletter.core_value = 8;
           }
           //$d(new Date((newsletter.backup_date_formatted != null && newsletter.backup_blocks>0?  newsletter.backup_date_formatted : next_meeting)+" 00:00:01"), 'short')
           this.newsletter_dates = [];
           if(response.data.next_meeting){
            
              this.newsletter.send_date = response.data.next_meeting;
            this.newsletter_dates.push({value: response.data.next_meeting, html: 'Current Meeting: <span style="font-weight:bold;">'+ this.$d(new Date(response.data.next_meeting+" 00:00:01"), 'short')+"</span>"})
           }
           if(this.newsletter.backup_date_formatted){
              if(this.newsletter.send_date==null){
                this.newsletter.send_date = this.newsletter.backup_date_formatted;
              }
              this.newsletter_dates.push({value: this.newsletter.backup_date_formatted, html: 'Previous Meeting: <span style="font-weight:bold;">'+ this.$d(new Date(this.newsletter.backup_date_formatted+" 00:00:01"), 'short')+"</span>"})
           }
           this.next_meeting = response.data.next_meeting;
           this.newsletter.asks_missing = response.data.missing;
           this.tracking_nums = [];
              for(var i=0; i<this.trackingOptions.length;i++){
                if((response.data.tracking_nums & Math.pow(2,i)) != 0){
                  this.tracking_nums.push(this.trackingOptions[i]);
                }
              }
              this.no_data = [];
              for(i=0; i<this.tracking_nums.length;i++){
                if((this.newsletter.tracking_periods & this.tracking_nums[i].value) != 0){
                  this.newsletter.performance_select.push(this.tracking_nums[i]);
                }
                if(!response.data.performance_data.includes(this.tracking_nums[i].value)){
                  this.no_data.push(this.tracking_nums[i].value);
                }
              }
            //!(this.official==0 && this.startupObjects.indexOf(v.id)==-1) && !(this.official==1 && this.officialObjects.indexOf(v.id)==-1) && !(this.official==2 && this.rstObjects.indexOf(v.id)==-1)
            this.tempObjects = this.tempObjects.filter(v => {
               if(this.isCorporateConnections && this.is_parent){
                  return this.ccRegionalObjects.indexOf(v.id)>-1;
                }else if(this.isCorporateConnections){
                  return this.ccObjects.indexOf(v.id)>-1;
               }else if(this.official==0){
                return this.startupObjects.indexOf(v.id)>-1;
              }else if(this.official==1 && this.is_parent){
                return this.regionalObjects.indexOf(v.id)>-1;
              }else if(this.official==1 && !this.is_parent){
                return this.officialObjects.indexOf(v.id)>-1;
              } else if(this.official==2){
                return this.rstObjects.indexOf(v.id)>-1;
              }
              return false;
            });
            this.galleryPhotos = response.data.newsletter.gallery_photos? response.data.newsletter.gallery_photos : [];
            var custom_blocks = response.data.custom_blocks;
            this.bottomMessage.update = this.bottomMessage.text = this.newsletter.bottom_message;
            this.topMessage.update = this.topMessage.text = this.newsletter.top_message;
            this.meetingRecap.update = this.meetingRecap.text = this.newsletter.meeting_recap;
            this.newsNotifications.update = this.newsNotifications.text = this.newsletter.news_notifications;
            this.closingNote.update = this.closingNote.text = this.newsletter.closing_note;
            this.photoDescription.update = this.photoDescription.text = this.newsletter.photo_description;
            this.mediaHeader.update = this.mediaHeader.text = this.newsletter.media_header;
            var layoutIds = this.newsletter.layout.split(",");
            for(var x=0 ;x<layoutIds.length; x++){
              var o = layoutIds[x].split(";");
              for(var j=0; j<this.tempObjects.length;j++){
                if(o[0] == this.tempObjects[j].id+""){
                  var t = JSON.parse(JSON.stringify(this.tempObjects[j]));
                  if(o.length>1){
                    if(o.length>2){
                      for(var j=0; j<custom_blocks.length; j++){
                        if(custom_blocks[j].id == o[0] && o[2] == custom_blocks[j].custom_id){
                          t = JSON.parse(JSON.stringify(custom_blocks[j]));
                          t.resizeable = false;
                          
                          break;
                        }
                      }
                    }
                    t.cspan = parseInt(o[1]);
                  }
                  t.members = [];
                  this.newsletterObjects.push(t);
                  break;
                }
              }
            }
            for(var y=0; y<this.tempObjects.length;y++){
               var n =this.newsletterObjects.filter(v => v.id==this.tempObjects[y].id);
                if(n.length==0 || (this.tempObjects[y].max>1 && n.length< this.tempObjects[y].max)){
                  this.unusedObjects.push(this.tempObjects[y]);
                }
          }
            var t  = this.newsletter.layout.split(",");
            for(i=0; i<t.length; i++){
              o = t[i].split(";");
              this.newsletter.split_layout.push(o[0]);
            }
            this.newsletter.useruid = this.useruid;
            Object.assign(this.old_newsletter, this.newsletter);
            this.getMembers();
        }).catch((e) => { console.log(e);});
      },
      updateNewsletter() {
        this.newsletter.bottom_message = this.bottomMessage.text;
        this.newsletter.top_message = this.topMessage.text;
        this.newsletter.meeting_recap = this.meetingRecap.text;
        this.newsletter.news_notifications = this.newsNotifications.text;
        this.newsletter.closing_note = this.closingNote.text;
        this.newsletter.photo_description = this.photoDescription.text;
        this.newsletter.media_header = this.mediaHeader.text;
        this.newsletter.tracking_periods = 0;
        for(var i=0; i<this.newsletter.performance_select.length;i++){
          this.newsletter.tracking_periods |= this.newsletter.performance_select[i].value;
        }
        var t = "";
        for(i=0; i<this.newsletterObjects.length;i++){
          t+= (t.length==0? "": ",")+ this.newsletterObjects[i].id+";"+this.newsletterObjects[i].cspan+(this.newsletterObjects[i].custom_id>0? ";"+this.newsletterObjects[i].custom_id : "");
        }
        this.newsletter.layout = t;
        
      this.newsletter.useruid = this.useruid;

        Object.assign(this.old_newsletter, this.newsletter);
        this.updateDisabledEmails();

        this.newsletter.custom_objects = this.newsletterObjects.filter(v => v.custom_id>0);
        for(i=0; i<this.newsletter.custom_objects.length;i++){
          if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length==1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members[0].id+'';
          }else if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length>1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members.reduce((v1,v2) => (v1.id? v1.id : v1)+","+v2.id);
          }else{
            this.newsletter.custom_objects[i].member_ids = '';
          }
        }
        this.newsletter.gallery_photos = this.galleryPhotos;
        if(this.newsletter.custom_objects==null){
          this.newsletter.custom_objects = [];
        }
        this.$http.post("/api/organization/newsletter/update"+(this.useruid==''? "" : "/byuseruid"), this.newsletter).then((response) => {
          if (response.data.success === true) {
            if(this.useruid==''){
              this.justSaved = true;
              this.back();
            }else{
              this.$bvToast.toast(this.$t('newsletter.successful_save'), {
                variant: 'success',
                solid: true
              });
            }
            
          }
        }).catch(() => { this.$bvToast.show('serverError');});
      },
      showSendModal(use_backup){
        this.send_backedup = use_backup;
        this.newsletter.bottom_message = this.bottomMessage.text;
        this.newsletter.top_message = this.topMessage.text;
        this.newsletter.meeting_recap = this.meetingRecap.text;
        this.newsletter.news_notifications = this.newsNotifications.text;
        this.newsletter.closing_note = this.closingNote.text;
        this.newsletter.photo_description = this.photoDescription.text;
        this.newsletter.media_header = this.mediaHeader.text;
        this.newsletter.useruid = this.useruid;
        if(this.is_parent){
          this.$http.post("/api/region/members/newsletter/count"+(this.useruid==''? "" : "/byuseruid"), {}).then((response) => {
            if (response.data.success) {
              this.regionalMembers = response.data;
                this.showNewsletterRegionalSend = true;
            }
          }).catch(() => { this.$bvToast.show('serverError');});
        }else{
          if(this.newsletter.meeting_recap == null || this.newsletter.meeting_recap.length<15){
            this.confirm_step = 0;
          }else{
            this.confirm_step = 1;
          }
          this.showNewsletterSend = true;
        }
        
      },
      showSendTestModal(use_backup){
        this.send_backedup = use_backup;
        this.newsletter.bottom_message = this.bottomMessage.text;
        this.newsletter.top_message = this.topMessage.text;
        this.newsletter.meeting_recap = this.meetingRecap.text;
        this.newsletter.news_notifications = this.newsNotifications.text;
        this.newsletter.closing_note = this.closingNote.text;
        this.newsletter.photo_description = this.photoDescription.text;
        this.newsletter.media_header = this.mediaHeader.text;
        this.newsletter.useruid = this.useruid;
        this.testEmail = this.getCookie("test_email");
        this.validateEmail();
        this.showTestNewsletter = true;
      },  
      confirmSend(){
        if(this.confirm_step==0){
          this.confirm_step+=1;
        }else if(this.confirm_step == 1){
          this.showNewsletterSend = false;
          this.emailNewsletter(false);
        }
      },
      confirmRegionalSend(){
        this.showNewsletterRegionalSend = false;
        this.emailNewsletter(false);
      },
      confirmTest(){
        this.showTestNewsletter= false;
        this.setCookie("test_email", this.testEmail);
        this.emailNewsletter(true);
      },
      sendAskRequestEmails(){
        this.showReferralConfirm = false;
         this.$http.post("/api/member/referral/request/all/email"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid }).then(response => {
          if (response.data.success === true) {
            this.$bvToast.toast(this.$t('newsletter.successful_request_send'), {
                variant: 'success',
                solid: true
              });
          } 
        })
        .catch(() => {});
      },
      emailNewsletter(test){
        Object.assign(this.old_newsletter, this.newsletter);
        this.newsletter.custom_objects = this.newsletterObjects.filter(v => v.custom_id>0);
        for(var i=0; i<this.newsletter.custom_objects.length;i++){
           if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length==1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members[0].id+'';
          }else if(this.newsletter.custom_objects[i].members && this.newsletter.custom_objects[i].members.length>1){
            this.newsletter.custom_objects[i].member_ids = this.newsletter.custom_objects[i].members.reduce((v1,v2) => (v1.id? v1.id : v1)+","+v2.id);
          }else{
            this.newsletter.custom_objects[i].member_ids = '';
          }
        }
        this.newsletter.gallery_photos = this.galleryPhotos;
        this.$http.post("/api/organization/newsletter/update"+(this.useruid==''? "" : "/byuseruid"), this.newsletter).then((response) => {
          if (response.data.success === true) {
            this.$http.post("/api/organization/newsletter/email/current"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid, test: test, use_backup: this.send_backedup, test_email: this.testEmail, regionalSendOptions: this.regionalSendOptions, date: this.newsletter.send_date }).then(response => {
            if (response.data.success === true) {
              if(test){
                this.$bvToast.toast(this.$t('newsletter.successful_test')+" "+response.data.message, {
                  variant: 'success',
                  solid: true
                });
              }else{
                this.$bvToast.toast(this.$t('newsletter.successful_send'), {
                  variant: 'success',
                  solid: true
                });
              }
              
            } 
          }).catch(() => {});
          }
          });
        
      },
      back() {
        if(!this.permissions.organization.is_parent || this.permissions.organization.rst){
          router.push("/admin/dashboard");
        }else{
          router.push("/admin/regiondash");
        }
        
      },
      showImagePrompt(command,maxwidth) {
          this.command = command;
          this.maxwidth = maxwidth;
        this.showImageModal = true;
      },
   
      setImageByURL(src){
          if(this.command != null){
            this.command({ src: src});
            this.showImageModal = false;
            this.command = null;
          }
      },
     
      openPhotoEdit(sf, d,f, maxwidth, maxheight){
        this.imageEdit= {data: "", preview: "", successFunc: null, fixed: true,maxwidth:0,maxheight:0}
        this.showPhotoEdit=true
        this.imageEdit.fixed = f;
        this.imageEdit.successFunc = sf;
        this.imageEdit.maxwidth = maxwidth;
        this.imageEdit.maxheight = maxheight;
        var self = this;
        if(d && d.length>0){
          this.imageEdit.data = d;
          this.$refs.cropper.replace(self.imageEdit.data);
         setTimeout(function () {
              self.cropMove();
            }, 200);
        }else{
          this.imageEdit.data = "";
          this.$refs.cropper.replace(null);
        }
      },
      cropMove() {
        this.imageEdit.preview = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8);
      },
      setImage(e) {
        const file = e.target.files[0];
        if (!file.type.includes('image/')) {
          return;
        }
        if (typeof FileReader === 'function') {
          var reader = new FileReader();
          var self = this;
          reader.onload = function(e) {
              self.imageEdit.data = e.target.result;
              self.$refs.cropper.replace(e.target.result);
              setTimeout(function () {
                self.cropMove();
              }, 200);
              
          }
          reader.readAsDataURL(file);
          
        }
      },
      resizeDataUrl(filedata, imagetype, scale_width, scale_height, onEnd){
        var img = document.createElement("img");
        img.src = filedata;
        img.onload = function(){
          var width = img.width;
          var height = img.height;
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
         
          ctx.drawImage(img, 0, 0);
          var MAX_WIDTH = scale_width>0? scale_width : width;
          var MAX_HEIGHT = scale_height>0? scale_height : height;
          if (width > height) {
              if (width > MAX_WIDTH) {
                  height *= MAX_WIDTH / width;
                  width = MAX_WIDTH;
              }
          } else {
              if (height > MAX_HEIGHT) {
                  width *= MAX_HEIGHT / height;
                  height = MAX_HEIGHT;
              }
          }
          canvas.width = width;
          canvas.height = height;
          if(imagetype.includes("j")){
            ctx.fillStyle = '#fff'; 
            ctx.fillRect(0, 0, canvas.width, canvas.height);
          }
          ctx.drawImage(img, 0, 0, width, height);
          var dataurl = canvas.toDataURL(imagetype, 0.8);
          onEnd(dataurl);
        }
      },
      cropImage() {
        if(this.$refs.cropper.getCroppedCanvas()){
          if(this.imageEdit.maxwidth>0 || this.imageEdit.maxheight>0){
            var self = this;
            this.resizeDataUrl(this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8), 'image/jpeg', this.imageEdit.maxwidth, this.imageEdit.maxheight, function(d){
              self.imageEdit.successFunc(d);
            });
          }else{
            this.imageEdit.successFunc(this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8));
          }
        }
        this.showPhotoEdit = false;
      },
      getMembers() {
        this.$http.post(this.is_parent? "/api/organization/members/all/select" : ("/api/organization/members/email/select"+(this.useruid==''? "" : "/byuseruid")) , {useruid: this.useruid }).then((response) => {
          this.members = response.data.members;
          this.members.unshift({id: 0, name: ""});
          this.member_map = new Map();
          for(var i=0; i<this.members.length;i++){
            this.member_map.set(this.members[i].id, this.members[i]);
          }
          if(this.is_parent){
            for(var i=0; i<this.newsletterObjects.length; i++){
              if(this.newsletterObjects[i].member_ids){
                 var sp = this.newsletterObjects[i].member_ids.split(",");
                 //sp = sp.map(id => ))
                  this.newsletterObjects[i].members = [];
                  for(var j=0; j<sp.length;j++){
                    var k = this.member_map.get(parseInt(sp[j]));
                    if(k && k != undefined && k.id>0){
                      this.newsletterObjects[i].members.push(k);
                    }
                  }
              }
            }
          }
        }).catch(() => {});
      },
      getDisabledEmails() {
        this.$http.post("/api/organization/get/disabledemails"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid }).then((response) => {
          if(response.data.success){
            this.organization = response.data.organization;
            this.joint_meeting = response.data.organization.joint_organization>0;
          }
        }).catch(() => {});
      },
      updateDisabledEmails() {
        this.organization.useruid = this.useruid;
        this.$http.post("/api/organization/update/disabledemails"+(this.useruid==''? "" : "/byuseruid"), this.organization).catch(() => {});
      },
      getMediaDefined(){
          this.$http.post("/api/organization/media/count"+(this.useruid==''? "" : "/byuseruid"), {useruid: this.useruid }).then((response) => {
          this.media_links = response.data.media_links;
        }).catch(() => {});
      },
      openDialog() {
        document.getElementById('fileid').click();
      },
      rotateImageLeft(){
        this.$refs.cropper.rotate(90);
        this.cropMove();
      },
      rotateImageRight(){
        this.$refs.cropper.rotate(-90);
        this.cropMove();
      },
      flipImageX(){
        var d = this.$refs.cropper.getData()
        this.$refs.cropper.scaleX(d.scaleX*-1);
        this.cropMove();
      },
      flipImageY(){
        var d = this.$refs.cropper.getData()
        this.$refs.cropper.scaleY(d.scaleY*-1);
        this.cropMove();
      },
    },
    beforeRouteLeave (to, from, next) { 
      if(this.justSaved){
        next();
        return;
      }

      if(JSON.stringify(this.newsletter) != JSON.stringify(this.old_newsletter)){
        const answer = window.confirm(this.$t('newsletter.unsaved_changes'))
        if(answer){
          next();
        }else{
          next(false);
        }
      }else{
        if((this.bottomMessage.text!=null && this.old_newsletter.bottom_message!=null && this.bottomMessage.text.replace(/\s/g, "") != this.old_newsletter.bottom_message.replace(/\s/g, ""))
        || (this.topMessage.text!=null && this.old_newsletter.top_message!=null && this.topMessage.text.replace(/\s/g, "") != this.old_newsletter.top_message.replace(/\s/g, ""))
        || (this.meetingRecap.text!=null && this.old_newsletter.meeting_recap!=null && this.meetingRecap.text.replace(/\s/g, "") != this.old_newsletter.meeting_recap.replace(/\s/g, ""))
        || (this.newsNotifications!=null && this.old_newsletter.news_notifications!=null && this.newsNotifications.text.replace(/\s/g, "") != this.old_newsletter.news_notifications.replace(/\s/g, ""))
        || (this.closingNote!=null && this.old_newsletter.closing_note!=null && this.closingNote.text.replace(/\s/g, "") != this.old_newsletter.closing_note.replace(/\s/g, ""))
        || (this.photoDescription!= null && this.old_newsletter.photo_description!= null && this.photoDescription.text.replace(/\s/g, "") != this.old_newsletter.photo_description.replace(/\s/g, ""))){
          const answer = window.confirm(this.$t('newsletter.unsaved_changes'))
          if(answer){
            next();
          }else{
            next(false);
          }
        }else{
         /* var foundDiff = false;
          for(var i=0;i<this.newsletterObjects.length;i++){
            if(this.newsletterObjects[i].update != undefined){
              if(this.newsletterObjects[i].update.replace(/\s/g, "") != this.newsletterObjects[i].text.replace(/\s/g, "")){
                
              }
            }
            if(this.newsletterObjects[i].title != undefined){
            }
            if(this.newsletterObjects[i].member_ids != undefined){

            }
            
          }*/
          next();
        }
      }
    },
    destroyed() {
      this.removeClass(document.getElementById("menu-newsletter"), "active-menu");
      this.removeClass(document.getElementById("menu-meeting"), "active-menu");
    },
    mounted() {
      if(this.$route.params.useruid){
        this.useruid = this.$route.params.useruid;
      }
      this.addClass(document.getElementById("menu-newsletter"), "active-menu");
      this.addClass(document.getElementById("menu-meeting"), "active-menu");
      
      this.getDisabledEmails();
       this.getAllowTopPerformers();
       this.getMediaDefined();
        
      }
    }
</script>
